import { List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { ArrowForward } from '@mui/icons-material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useAsync } from './async-hook';
import { appNameToDisplayName } from './datasource-info';
import { getSystemStatus } from './queries';
import { createOverviewRoute } from './routes';
import { SystemStatus } from './SystemStatus';
import { useShowLogin } from './useShowLogin';

export const Introduction = () => {
  const { t } = useTranslation();
  const systemStatusState = useAsync(getSystemStatus);

  const showLogin = useShowLogin(systemStatusState);

  return (
    <Stack spacing={4}>
      <div>
        <Typography variant="h1">{t('introduction.title')}</Typography>
        <List>
          {(
            t('introduction.processSteps', {
              returnObjects: true,
            }) as string[]
          ).map((step, i) => (
            <ListItem key={i}>
              <ListItemIcon>
                <ArrowForward />
              </ListItemIcon>
              <ListItemText>{step}</ListItemText>
            </ListItem>
          ))}
        </List>
      </div>
      <div>
        <SystemStatus systemStatusState={systemStatusState} />
      </div>
      {showLogin && (
        <div>
          <Button
            id="toLoginButton"
            type="submit"
            color="primary"
            variant="contained"
            component={Link}
            fullWidth
            to={createOverviewRoute()}
          >
            {t('Naar inloggen')}
          </Button>
        </div>
      )}
      <div>
        <Typography variant="h2">
          {t('introduction.dataTitle', {
            dataSources: `${appNameToDisplayName.mijnuwv}, ${
              appNameToDisplayName.mijnoverheid
            } ${t('and')} ${appNameToDisplayName.belastingdienst}`,
          })}
        </Typography>
        <ul>
          {(
            t('introduction.dataNames', {
              returnObjects: true,
            }) as string[]
          ).map((dataName, i) => (
            <Typography variant="body1" component="li" key={i}>
              {dataName}
            </Typography>
          ))}
        </ul>
      </div>
    </Stack>
  );
};
